// Module
var code = "<div><span></span></div>";
// Exports
export default code;